import createAction from './createAction';

// 1. Initial state
const initialState = {};

// 2. Actions
const USER_DETAILS_LOADING_STARTED = 'userDetails/USER_DETAILS_LOADING_STARTED';
const USER_DETAILS_LOADING_FINISHED = 'userDetails/USER_DETAILS_LOADING_FINISHED';

// 3. Action creators
export function userDetailsLoadingStarted() {
  return createAction(USER_DETAILS_LOADING_STARTED)();
}

export function userDetailsLoadingFinished(userDetails) {
  return createAction(USER_DETAILS_LOADING_FINISHED)(userDetails);
}

// 4. Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case USER_DETAILS_LOADING_STARTED:
      return state;
    case USER_DETAILS_LOADING_FINISHED:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}
